"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VerticalSideMenuMainPage = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactRouterDom = require("react-router-dom");

var _styles = require("./styles");

var _iconLogoContentoh = _interopRequireDefault(require("../../../assets/images/verticalSideMenuMainPage/iconLogoContentoh.svg"));

var _iconLogo = _interopRequireDefault(require("../../../assets/images/verticalSideMenuMainPage/iconLogo.svg"));

var _jsxRuntime = require("react/jsx-runtime");

var VerticalSideMenuMainPage = function VerticalSideMenuMainPage(_ref) {
  var _ref$menuoption = _ref.menuoption,
      menuoption = _ref$menuoption === void 0 ? [] : _ref$menuoption,
      containerdash = _ref.containerdash;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      trueBar = _useState2[0],
      setTrueBar = _useState2[1];

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactRouterDom.BrowserRouter, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.ContainerPrincipal, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Container, {
        bar: trueBar,
        onMouseOver: function onMouseOver() {
          return setTrueBar(true);
        },
        onMouseOut: function onMouseOut() {
          return setTrueBar(false);
        },
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: "navbar-top",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
            src: trueBar ? _iconLogoContentoh.default : _iconLogo.default,
            alt: "Logo",
            className: "logo"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: "option",
            children: menuoption.map(function (item, index) {
              var _item$suboption;

              return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                className: "option-div",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.NavLinkOption, {
                  to: item.path,
                  bar: trueBar.toString(),
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
                    src: item.icon,
                    alt: item.title
                  }), trueBar ? /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
                    children: item.title
                  }) : null]
                }), item === null || item === void 0 ? void 0 : (_item$suboption = item.suboption) === null || _item$suboption === void 0 ? void 0 : _item$suboption.map(function (subitem, index) {
                  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                    className: "sub-option",
                    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.NavLinkOption, {
                      to: subitem.path,
                      className: "sub-option-link",
                      bar: trueBar.toString(),
                      children: trueBar ? subitem.title : null
                    })
                  }, index);
                })]
              }, index);
            })
          })]
        })
      }), containerdash]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.GlobalStyle, {})]
  });
};

exports.VerticalSideMenuMainPage = VerticalSideMenuMainPage;